/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { EntitlementDetails } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import { useTenantContext } from '../tenant-context/index.tsx';

/**
 * Returns product entitlement details for the current tenant.
 *
 * @agent-skills: tenant-context
 */
export const useProductEntitlementDetails = (): Record<string, EntitlementDetails> | null => {
	const tenantContext = useTenantContext();
	return (tenantContext && tenantContext.productEntitlementDetails) || null;
};
